import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { KnowMoreAboutMasterPreferredRatingsComponent } from '../../../../../preferences/know-more-about-master-preferred-ratings/know-more-about-master-preferred-ratings.component';
import { MatDialog } from '@angular/material/dialog';
import { PreferencesService } from '../../../../../service/preferences.service';
import { Keys, StorageService } from '../../../../../service/storage.service';
import { Toaster, Type } from '../../../../../toaster/Toaster';
import { Preferences } from '../../../../../model/preferences.model';
import { PreferredCategories, Rating } from '../../../../../model/portfolio-preferences.model';
import { cloneDeep, flatten } from 'lodash';
import { InvestmentApplicationFlowStep } from '../investment-application-flow.step';
import { RatingSelectorComponent } from '../../../../../portfolio-creation/rating-selector/rating-selector.component';
import { ActivatedRoute, Data, Router } from '@angular/router';
import { executeWithLoader, LoaderStatus } from '../../../../../utils/loader.util';
import { DiscardChangesPromptComponent } from '../../../../../discard-changes-prompt/discard-changes-prompt.component';
import { AnalyticsTracker } from '../../../../../utils/AnalyticsTracker';
import { RatingLabels } from '../../../../../model/rating-labels.model';
import { MatCheckboxChange } from '@angular/material';
import { ConsentType } from '../../../../../model/ConsentAudit';
import { ConsentService } from '../../../../../service/consent.service';
import { ConfigService } from '../../../../../service/config.service';
import { UserAttributeService } from '../../../../../service/finzy-flex/user/user-attribute.service';
import { FormArray, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { AttributeCode, AttributeValue, nCashFrequencies, nCashDates, InvestmentPreference, UserAttributeInterface, RISK_RANGE } from '../../../../../model/finzy-flex/user-attribute.model';
import { ConsentDialogComponent } from './consent-dialog/consent-dialog.component';
import { ProductCode, ProductList, RiskScore } from '../../../../../model/finzy-flex/product-list.model';
import { ProductService } from '../../../../../service/finzy-flex/product/product.service';

@Component({
  selector: 'app-investment-preferences-step',
  templateUrl: './investment-preferences.component.html',
  styleUrls: ['./investment-preferences.component.css'],
  providers: [PreferencesService]
})

export class InvestmentPreferencesComponent implements OnInit, AfterViewInit {

  @ViewChild(RatingSelectorComponent, { static: false })
  ratingSelectorComponent: RatingSelectorComponent;

  preferences: Preferences;
  preferencesUpdated: boolean;
  preferencesSettingOption: boolean;
  activeFinzyVersion: string;
  applicableProducts: any;
  subProducts = [];
  fundAllocationPreferenceForm: FormGroup;
  formBuilder: FormBuilder;
  visible: boolean = true;
  dataLoader: boolean = false;
  userAttribute = [];
  accordionExpansion = {
    finzyPro: false,
    reinvest: false,
    finzyBolt: false,
    swift: false,
    nCash: false
  };
  setPannel: number = -1;
  currentPannel: number = -1;
  loaderStatus = new LoaderStatus();
  preferredCategories: PreferredCategories[];
  step: InvestmentApplicationFlowStep;

  selectedPreferencesBucket: string[];
  availablePreferences: RatingLabels;

  finzyBoltConsentGranted: boolean;
  finzyBoltNeedsAttention: boolean;
  frequencies = nCashFrequencies;
  dates = nCashDates;
  swiftExpanded: boolean;
  nCashExpanded: boolean;
  showFormPreferenceForm: boolean = false;

  /* * * * * * * * * * * * * * * * * * * * * * * * * loanPreference end * * * * * * * * * * * * * * * * * * * * * * * */
  public loanPreferenceExpanded: boolean;
  public expectedReturn = {
    F6: 0,
    F12: 0,
    F24: 0,
    F36: 0,
    F18: 0,
  };
  public riskScore: RiskScore;

  public riskRangeScore = {
    "A1-A6": 1,
    "B1-B6": 3,
    "C1-C6": 5
  };

  public maxLoanAmountToggle: string = '10';
  public tenurePreferenceToggle: string = '36';
  public interestRateRiskRangeToggle: Array<string> = Object.values(RISK_RANGE);

  private userAttributes: InvestmentPreference[] = [];
  private backupSwiftAttribute: InvestmentPreference[] = [];
  private product: ProductList;
  private isPreferenceExist: boolean = true;
  private previousUserAttribute: InvestmentPreference[];

  public isFinzyBoltEnabled: boolean = false;
  public userAttributesForm: FormGroup;
  public isEdited: boolean = false;
  private isSwiftEnabled: boolean = false;
  private isNCashModified: boolean = false;
  private isSwiftModified: boolean = false;

  private readonly router: Router;
  private readonly matDialog: MatDialog;
  private readonly analyticsTracker: AnalyticsTracker;
  private readonly storageService: StorageService;
  private readonly preferencesService: PreferencesService;
  private readonly consentService: ConsentService;
  private readonly configService: ConfigService;
  private readonly userAttributeService: UserAttributeService;
  private readonly productService: ProductService;
  private pannels = [, , 'MAX_LIMIT', 'INTEREST_ONLY',];

  constructor(activatedRoute: ActivatedRoute, router: Router, analyticsTracker: AnalyticsTracker, matDialog: MatDialog,
    storageService: StorageService, preferencesService: PreferencesService, consentService: ConsentService,
    formBuilder: FormBuilder, configService: ConfigService, userAttributeService: UserAttributeService,
    productService: ProductService) {
    this.router = router;
    this.matDialog = matDialog;
    this.analyticsTracker = analyticsTracker;
    this.storageService = storageService;
    this.preferencesService = preferencesService;
    this.consentService = consentService;
    this.configService = configService;
    this.userAttributeService = userAttributeService;
    this.productService = productService;
    this.step = new InvestmentApplicationFlowStep('Investment Preferences',
      'Set your investment preferences to choose how your investments are allocated to loans', '/invest/investment-preferences',
      '/invest/lender-nominee', '/lenderuploaddocuments', false, false);
    this.step.isComplete = true;

    this.preferencesSettingOption = false;
    this.preferredCategories = [];
    this.availablePreferences = RatingLabels.defaults();
    this.selectedPreferencesBucket = [];
    if (this.storageService.getItem(Keys.INVESTMENT_PREFERENCES)) {
      this.preferencesUpdated = true;
    } else {
      this.preferencesUpdated = false;
    }
    activatedRoute.data.subscribe((data: Data) => {
      this.preferences = data.investmentPreferences;
      if (!this.preferences) {
        this.preferences = Preferences.createDefault();
      }
      this.applicableProducts = data.product;
      this.isFinzyBoltEnabled = !!data.userAttributes.data[0]?.automaticInvestmentsFromWallet;
      this.userAttributes = data.userAttributes.data[0]?.investmentPreferences ? data.userAttributes.data[0].investmentPreferences : [];
      if (!data.userAttributes.count) {
        this.isPreferenceExist = false;
      }
    });
    this.formBuilder = formBuilder;

    this.userAttributesForm = formBuilder.group({
      nCash: formBuilder.control('setupLaterNCash'),
      frequency: formBuilder.control(null),
      date: formBuilder.control(null),
      loanPreference: formBuilder.group({
        maxLoanAmount: formBuilder.control(null),
        tenurePreference: formBuilder.control(null),
        expectedReturn: formBuilder.group({
          F6: formBuilder.control(null),
          F12: formBuilder.control(null),
          F24: formBuilder.control(null),
          F36: formBuilder.control(null),
          F18: formBuilder.control(null),
        }),
        interestRateRiskRange: [
          formBuilder.control(null),
          Validators.compose([Validators.required, Validators.minLength(2)]),
        ],
      }),
    });

    this.fundAllocationPreferenceForm = this.formBuilder.group({
      swift: this.formBuilder.control('setupLaterSwift'),
      fundAllocation: this.formBuilder.array([]),
    });
  }

  async ngOnInit() {
    this.getRiskScore();
    this.activeFinzyVersion = this.configService.getActiveFinzyVersion();
    this.backupSwiftAttribute = cloneDeep(this.userAttributes.filter(attr => attr.attributeCode === AttributeCode.INVESTMENT_FUND_ALLOCATION));
    this.previousUserAttribute = cloneDeep(this.userAttributes);
    this.setNCashAttribute();
    await this.populateForm();
    this.onValueChangeSwift();
    try {
      this.preferredCategories = this.preferences ? this.convertRatingsToPreferredCategories(this.preferences.preferredRatings) : [];
      this.selectRatingBucketPreferences();
      this.selectFinzyBoltPreferences();
    } catch (error) {
      Toaster.toast('Something went wrong while getting your preferences. Please try again later.', Type.Error);
    }
  }

  ngAfterViewInit(): void {
    this.onNCashValueChange();
  }

  afterExpand(portfolioType: string) {
    Object.keys(this.accordionExpansion).forEach(type =>
      this.accordionExpansion[type] = type.toString() === portfolioType ? true : false);
    if (portfolioType == 'swift') {
      this.swiftExpanded = true;
      if (this.fundAllocationPreferenceForm.controls.swift.value == AttributeValue.SWIFT) {
        this.setPannelHeader(0);
      }
    }
    if (portfolioType == 'nCash') {
      this.nCashExpanded = true;
      if (this.userAttributesForm.controls.nCash.value == AttributeValue.MAX_LIMIT) {
        this.setPannelHeader(2);
      }
      if (this.userAttributesForm.controls.nCash.value == AttributeValue.INTEREST_ONLY) {
        this.setPannelHeader(3);
      }
    }

    if (portfolioType == 'loanPreference') {
      this.loanPreferenceExpanded = true;
    }
  }
  afterCollapse(portfolioType?: string) {
    Object.keys(this.accordionExpansion).forEach(type => this.accordionExpansion[type] = false);
    if (portfolioType == 'swift') {
      this.swiftExpanded = false;
    }
    if (portfolioType == 'nCash') {
      this.nCashExpanded = false;
    }
    if (portfolioType == 'loanPreference') {
      this.loanPreferenceExpanded = true;
    }
  }
  async savePreferences() {
    try {
      if (this.step.isComplete) {
        await executeWithLoader(this.loaderStatus, async () => {
          const userId = this.storageService.getItem(Keys.PROFILE_ID);
          if (this.preferences.automaticInvestmentsFromWallet) {
            await this.consentService.saveConsent(ConsentType.LENDER_LOAN_AGREEMENT_REVIEWED);
          }
          const savedPreferences = await this.preferencesService.saveUserPreferences(userId, this.preferences);
          this.storageService.saveItem(Keys.INVESTMENT_PREFERENCES, 'true');
          Toaster.toast('Your preferences have been updated successfully!', Type.Success);
          this.preferences = savedPreferences;
          await this.next('Next');
        });
      }
    } catch (error) {
      this.stepComplete(false);
      Toaster.toast('Something went wrong while saving your preferences. Please try again later.', Type.Error);
    }
  }

  onPreferredCategoriesChanged(categories: PreferredCategories[]) {
    this.preferences.preferredRatings = new Set<Rating>(flatten(categories.map(category => category.ratingList)));
    if (this.ratingSelectorComponent.preferredCategories.length > 0 &&
      !this.ratingSelectorComponent.containsOnlyForbiddenRatings(this.ratingSelectorComponent.preferredCategories)) {
      this.stepChanged(true);
      this.selectRatingBucketPreferences();
    } else {
      this.stepChanged(false);
    }
  }

  convertRatingsToPreferredCategories(preferredRatings: Set<Rating>) {
    return <PreferredCategories[]>[{ ratingList: Array.from(preferredRatings) }];
  }
  onKnowMoreAboutFinzyProMasterPreferencesClicked() {
    this.matDialog.open(KnowMoreAboutMasterPreferredRatingsComponent);
  }
  onReinvestEMIPrincipalPreferenceChange(value: boolean): void {
    this.preferences.reinvest.emi.reinvestPrincipal = value;
    this.stepChanged(true);
  }

  onReinvestEMIInterestPreferenceChange(value: boolean): void {
    this.preferences.reinvest.emi.reinvestInterest = value;
    this.stepChanged(true);
  }

  onReinvestPrepaymentPreferenceChange(value: boolean): void {
    this.preferences.reinvest.prepayment.reinvestInterest = value;
    this.preferences.reinvest.prepayment.reinvestPrincipal = value;
    this.stepChanged(true);
  }

  onAutomaticInvestmentsFromWalletPreferenceChange(value: boolean): void {
    this.preferences.automaticInvestmentsFromWallet = value;
    this.stepChanged(true);
    if (this.preferences.automaticInvestmentsFromWallet) {
      if (!this.finzyBoltConsentGranted) {
        this.stepComplete(false);
      } else {
        this.stepComplete(true);
      }
    } else {
      this.finzyBoltConsentGranted = false;
      this.stepComplete(true);
    }
  }

  onConsentChange(event: MatCheckboxChange) {
    this.checkConsentStatus(event.checked);
  }

  private checkConsentStatus(isConsentGranted: boolean): boolean {
    this.finzyBoltConsentGranted = isConsentGranted;
    if (this.preferences.automaticInvestmentsFromWallet) {
      if (!isConsentGranted) {
        this.stepChanged(true);
        this.stepComplete(false);
        return false;
      } else {
        this.stepComplete(true);
        return true;
      }
    }
  }

  private async selectFinzyBoltPreferences() {
    if (this.preferences.automaticInvestmentsFromWallet) {
      const userId = this.storageService.getItem(Keys.PROFILE_ID);
      const consents = await this.consentService.getConsentsForUserByType(userId, ConsentType.LENDER_LOAN_AGREEMENT_REVIEWED);
      const isConsentGranted = consents && consents.length > 0 ? true : false;
      const consentStatus = !this.checkConsentStatus(isConsentGranted);
      this.finzyBoltNeedsAttention = consentStatus;
      if (this.finzyBoltNeedsAttention) {
        this.storageService.saveItem(Keys.INVESTMENT_PREFERENCES, 'false');
      }
    }
  }

  private selectRatingBucketPreferences() {
    this.selectedPreferencesBucket = [];
    this.preferences.preferredRatings.forEach(rating => {
      const ratingLabel = this.availablePreferences.find(availablePreference =>
        availablePreference.value.ratingList.includes(rating));
      if (ratingLabel && !this.selectedPreferencesBucket.includes(ratingLabel.label)) {
        this.selectedPreferencesBucket.push(ratingLabel.label);
      }
    });
    this.selectedPreferencesBucket.sort();
  }

  onPreferencesSettingOptionChange() {
    this.preferencesUpdated = this.preferencesSettingOption;
    if (!!this.preferencesSettingOption) {
      this.fundAllocationPreferenceForm.markAllAsTouched();
      this.fundAllocationPreferenceForm.markAsDirty();
      this.userAttributesForm.markAllAsTouched();
      this.userAttributesForm.markAsDirty();
    }
  }

  private stepComplete(complete: boolean): void {
    this.step.isComplete = complete;
  }

  private stepChanged(status: boolean) {
    this.step.changed = status;
  }
  async next(event: string) {
    this.analyticsTracker.trackButtonClick(this.step.displayName, event);
    await this.router.navigate([this.step.nextLink]);
  }
  async previous() {
    if (this.step.changed) {
      const dialogRef = this.matDialog.open(DiscardChangesPromptComponent);
      const dialogResult = await dialogRef.afterClosed().toPromise();
      if (dialogResult) {
        await this.router.navigate([this.step.previousLink]);
      }
    } else {
      await this.router.navigate([this.step.previousLink]);
    }
  }
  /* * * * * * * * * * * * * * * * * * * * * * * * * Swift attribute starts * * * * * * * * * * * * * * * * * * * * * * * */

  private async populateForm() {

    this.isSwiftEnabled = !!this.userAttributes?.find(attribute => attribute.attributeCode === AttributeCode.AUTO_INVESTMENT_FROM_WALLET_TYPE
      && attribute.attributeValue === AttributeValue.SWIFT);

    if (this.isSwiftEnabled) {
      this.fundAllocationPreferenceForm.controls.swift.setValue(AttributeValue.SWIFT);
      this.fundAllocationPreferenceForm.controls.fundAllocation.setValidators([this.allocateFundFormValidator()]);
      this.fundAllocationPreferenceForm.controls.fundAllocation.updateValueAndValidity();
    }

    this.applicableProducts?.data.forEach((element: any) => {
      if (new Date(element.productVersions[0].startDate).getTime() <= new Date().getTime() &&
        new Date().getTime() <= new Date(element.productVersions[0].endDate).getTime()) {
        this.subProducts.push({
          name: element.productVersions[0].productAttributes.find(attribute => attribute.code == ProductCode.NAME) ? element.productVersions[0].productAttributes.find(attribute => attribute.code == ProductCode.NAME).value.toString() : element.name,
          mhp: element.productVersions[0].productAttributes.find(mhp => mhp.code === ProductCode.MHP_FRONTEND_DISPLAY)?.value,
          mhpName: element.productVersions[0].productAttributes.find(mhp => mhp.code === ProductCode.MHP)?.name ?? 'mhp',
          roi: element.productVersions[0].productAttributes.find(roi => roi.code === ProductCode.ROI).value,
        })
        this.productList().push(
          this.formBuilder.group({
            attributeCode: AttributeCode.INVESTMENT_FUND_ALLOCATION,
            attributeValue: this.formBuilder.control(this.getPreviousSwiftValue(element.code), [Validators.min(0), Validators.max(100)]),
            productCode: element.code,
            productVersion: element.productVersions[0].productVersion
          })
        );
      }
    });
  }

  private getPreviousSwiftValue(productCode: string): number {
    if (this.isSwiftEnabled) {
      const attributeValue = this.userAttributes.find(attr => attr.productCode === productCode)?.attributeValue;
      return attributeValue ? parseInt(attributeValue) : null;
    }
    return;
  }

  private onValueChangeSwift() {
    this.fundAllocationPreferenceForm.controls.swift.valueChanges.subscribe(async swift => {
      if (swift === AttributeValue.SWIFT) {
        this.fundAllocationPreferenceForm.controls.fundAllocation.setValidators([this.allocateFundFormValidator()]);
        this.fundAllocationPreferenceForm.controls.fundAllocation.updateValueAndValidity();
      }
      if (swift === 'setupLaterSwift') {
        this.fundAllocationPreferenceForm.controls.fundAllocation.clearValidators();
        this.fundAllocationPreferenceForm.controls.fundAllocation.updateValueAndValidity();
      }
      if (this.isPreferenceExist) {
        this.isEdited = true;
      }
    });
  }

  private allocateFundFormValidator(): ValidatorFn {
    return (formArray: FormArray): any => {
      let totalPercent = 0;
      let isFormValid: boolean = true;
      let shouldContainPositiveValue = true;
      formArray.controls.forEach((element: FormControl) => {
        if (element.value.attributeValue < 0 && element.value.attributeValue !== '' && element.value.attributeValue !== null) {
          shouldContainPositiveValue = false;
        }
        totalPercent = totalPercent + element.value.attributeValue;
      });
      if (!shouldContainPositiveValue) {
        isFormValid = false;
        return isFormValid ? null : { error: 'negativeValueValidatorError' }
      } else {
        isFormValid = totalPercent == 100 ? true : false;
        return isFormValid ? null : { error: 'allocateFundFormValidatorError' };
      }
    };
  }

  public productList(): FormArray {
    return this.fundAllocationPreferenceForm.get('fundAllocation') as FormArray;
  }

  isNumberKey(e): boolean {
    const charCode = (e.which) ? e.which : e.keyCode;
    return !(charCode > 31 && (charCode < 48 || charCode > 57));
  }

  public onInputChanges(event): any {
    const numberInput = event.path[1].getElementsByClassName('input-field');
    const inputLabel = event.path[1].getElementsByClassName('input-label');
    inputLabel[0].style.color = "#a6a6a6";
    numberInput[0].style.fontWeight = "900";
    numberInput[0].style.fontSize = "16px";
    numberInput[0].style.letterSpacing = "0.5px";
    if (event.target.value == '') {
      inputLabel[0].style.color = "#000000";
      numberInput[0].style.fontWeight = "400";
    }
  }
  /* * * * * * * * * * * * * * * * * * * * * * * * * nCash attribute starts * * * * * * * * * * * * * * * * * * * * * * * */

  private setNCashAttribute() {
    const isNCashAttributeFound = this.userAttributes.find(attr => attr.attributeCode === AttributeCode.NCASH_WD_LIMIT);

    if (isNCashAttributeFound) {
      const currentFrequency = this.userAttributes.find(att => att.attributeCode === AttributeCode.NCASH_WD_FREQUENCY).attributeValue;
      const currentDate = this.userAttributes.find(att => att.attributeCode === AttributeCode.NCASH_WD_DATE_OF_MONTH).attributeValue;
      const nCash = this.userAttributes.find(attr => attr.attributeCode === AttributeCode.NCASH_WD_LIMIT).attributeValue;
      this.userAttributesForm.controls.nCash.setValue(nCash.toString());
      this.userAttributesForm.controls.frequency.setValue(currentFrequency.toString());
      this.userAttributesForm.controls.date.setValue(currentDate.toString());
    }
  }

  private setNCashValidators() {
    this.userAttributesForm.controls.frequency.setValidators([Validators.required]);
    this.userAttributesForm.controls.date.setValidators([Validators.required]);
    this.userAttributesForm.controls.date.updateValueAndValidity();
    this.userAttributesForm.controls.frequency.updateValueAndValidity();
  }

  private removeNCashValidators() {
    this.userAttributesForm.controls.frequency.clearValidators();
    this.userAttributesForm.controls.date.clearValidators();
    this.userAttributesForm.controls.date.updateValueAndValidity();
    this.userAttributesForm.controls.frequency.updateValueAndValidity();
  }

  private resetNCashValue() {
    this.userAttributesForm.controls.date.setValue(null);
    this.userAttributesForm.controls.frequency.setValue(null);
  }

  private onNCashValueChange() {
    this.userAttributesForm.controls.nCash.valueChanges.subscribe(async nCash => {
      var pannel = this.userAttributesForm.value.nCash;

      if (nCash === AttributeValue.MAX_LIMIT || nCash === AttributeValue.INTEREST_ONLY) {
        this.resetNCashValue();
        this.setNCashValidators();
      } else {
        this.resetNCashValue();
        this.removeNCashValidators();
      }
      if (this.isPreferenceExist) {
        this.isEdited = true;
      }
    });
  }

  /* * * * * * * * * * * * * * * * * * * * * * * * * Form submit starts * * * * * * * * * * * * * * * * * * * * * * * */

  setPannelHeader(index: number) {
    if (index == this.setPannel) {
      return;
    }
    this.setPannel = index;
    if (index == 0) {
      this.swiftExpanded = true;
    }
    if ((index == 2) || (index == 3) || (index == 4)) {
      this.nCashExpanded = true;
    }
  }

  private isSwiftConsentRequired(userCurrentAttributes: InvestmentPreference[]): boolean {
    let isSwiftConsentRequired = false;
    const userCurrentSwiftAttribute = userCurrentAttributes.filter(attr => attr.attributeCode === AttributeCode.INVESTMENT_FUND_ALLOCATION);
    if (userCurrentSwiftAttribute.length === 0) return false;
    if (this.backupSwiftAttribute.length === 0 && userCurrentAttributes.length != 0) return true;
    this.backupSwiftAttribute.forEach(attr1 => {
      if (!userCurrentSwiftAttribute.some(attr2 => attr1.productCode === attr2.productCode && attr1.attributeValue === attr2.attributeValue?.toString())) {
        isSwiftConsentRequired = true;
      }
    })
    return isSwiftConsentRequired;
  }

  private checkSwiftModified(userCurrentAttributes: InvestmentPreference[]): boolean {
    const userCurrentSwiftAttribute = userCurrentAttributes.filter(attr => attr.attributeCode === AttributeCode.INVESTMENT_FUND_ALLOCATION);
    if (this.backupSwiftAttribute?.length != 0 && userCurrentSwiftAttribute?.length === 0) return true;
    if (this.backupSwiftAttribute?.length === 0 && userCurrentSwiftAttribute?.length != 0) return true;
    if (this.backupSwiftAttribute?.length === 0 && userCurrentSwiftAttribute.length === 0) return false;
    this.backupSwiftAttribute.forEach(attr1 => {
      if (!userCurrentSwiftAttribute.some(attr2 => attr1.productCode === attr2.productCode && attr1.attributeValue === attr2.attributeValue?.toString())) {
        this.isSwiftModified = true;
      }
    });
    return this.isSwiftModified;
  }

  private checkNCashModified(previousUserAttributes: InvestmentPreference[], userCurrentAttributes: InvestmentPreference[]): boolean {
    let previousNCashAvailable: boolean = false;
    let currentNCashAvailable: boolean = false;
    this.isNCashModified = false;
    previousNCashAvailable = !!previousUserAttributes.find((previousAttribute) => previousAttribute?.attributeCode == AttributeCode.NCASH_WD_LIMIT);
    currentNCashAvailable = !!userCurrentAttributes.find((currentAttribute) => currentAttribute?.attributeCode == AttributeCode.NCASH_WD_LIMIT);
    previousUserAttributes?.forEach((previousAttribute) => {
      if (userCurrentAttributes.some((currentAttribute) =>
        ((previousAttribute?.attributeCode == AttributeCode.NCASH_WD_LIMIT && currentAttribute?.attributeCode == AttributeCode.NCASH_WD_LIMIT) && previousAttribute?.attributeValue !== currentAttribute?.attributeValue) ||
        ((previousAttribute?.attributeCode == AttributeCode.NCASH_WD_FREQUENCY && currentAttribute?.attributeCode == AttributeCode.NCASH_WD_FREQUENCY) && previousAttribute?.attributeValue !== currentAttribute?.attributeValue) ||
        ((previousAttribute?.attributeCode == AttributeCode.NCASH_WD_DATE_OF_MONTH && currentAttribute?.attributeCode == AttributeCode.NCASH_WD_DATE_OF_MONTH) && previousAttribute?.attributeValue !== currentAttribute?.attributeValue) ||
        ((previousAttribute?.attributeCode == AttributeCode.NCASH_WD_AMOUNT && currentAttribute?.attributeCode == AttributeCode.NCASH_WD_AMOUNT) && previousAttribute?.attributeValue !== currentAttribute?.attributeValue))) {
        this.isNCashModified = true;
      }
    });
    if (previousNCashAvailable !== currentNCashAvailable) {
      this.isNCashModified = true;
    }
    return this.isNCashModified;
  }

  async onSubmitForm(): Promise<void> {
    this.userAttribute = [];

    if (this.fundAllocationPreferenceForm.controls.swift.value === AttributeValue.SWIFT) {
      this.userAttribute.push({
        attributeCode: AttributeCode.AUTO_INVESTMENT_FROM_WALLET_TYPE,
        attributeValue: AttributeValue.SWIFT
      });
      this.fundAllocationPreferenceForm.value.fundAllocation.forEach(attribute => {
        if (parseInt(attribute.attributeValue) >= 0 && parseInt(attribute.attributeValue) <= 100)
          this.userAttribute.push(attribute)
      })
    }

    if (this.userAttributesForm.controls.nCash.value === AttributeValue.MAX_LIMIT ||
      this.userAttributesForm.controls.nCash.value === AttributeValue.INTEREST_ONLY) {
      this.userAttribute.push(
        {
          attributeCode: AttributeCode.NCASH_WD_LIMIT,
          attributeValue: this.userAttributesForm.controls.nCash.value
        },
        {
          attributeCode: AttributeCode.NCASH_WD_FREQUENCY,
          attributeValue: this.userAttributesForm.controls.frequency.value
        },
        {
          attributeCode: AttributeCode.NCASH_WD_DATE_OF_MONTH,
          attributeValue: this.userAttributesForm.controls.date.value
        }
      )
    }

    if (this.isLoanFlexPreferenceExists(this.userAttributesForm.controls.loanPreference.value)) {
      this.userAttribute.push(
        {
          attributeCode: AttributeCode.PREFERRED_MAX_LOAN_ALLOCATION_AMOUNT_PERCENTAGE,
          attributeValue: this.userAttributesForm.controls.loanPreference.value.maxLoanAmount
        },
        {
          attributeCode: AttributeCode.PREFERRED_LOAN_TENURE,
          attributeValue: this.userAttributesForm.controls.loanPreference.value.tenurePreference
        }
      );

      if (this.userAttributesForm.controls.loanPreference.value.interestRateRiskRange.includes(RISK_RANGE.A1_A6)) {
        this.userAttribute.push({
          attributeCode: AttributeCode.FLEX_PREFERRED_RATING_LOW_RISK,
          attributeValue: RISK_RANGE.A1_A6
        });
      };

      if (this.userAttributesForm.controls.loanPreference.value.interestRateRiskRange.includes(RISK_RANGE.B1_B6)) {
        this.userAttribute.push({
          attributeCode: AttributeCode.FLEX_PREFERRED_RATING_MEDIUM_RISK,
          attributeValue: RISK_RANGE.B1_B6
        });
      };

      if (this.userAttributesForm.controls.loanPreference.value.interestRateRiskRange.includes(RISK_RANGE.C1_C6)) {
        this.userAttribute.push({
          attributeCode: AttributeCode.FLEX_PREFERRED_RATING_HIGH_RISK,
          attributeValue: RISK_RANGE.C1_C6
        });
      };
    }

    if (this.isSwiftConsentRequired(this.userAttribute)) {
      const isConsentsTaken = await this.matDialog.open(ConsentDialogComponent, { panelClass: ["dialog-responsive","consent-dialog"], width: '90%', maxWidth: '950px' }).afterClosed().toPromise();
      if (isConsentsTaken) {
        await this.consentService.saveConsent(ConsentType.LENDER_SWIFT_AGREEMENT_REVIEWED)
          .then(async () => await this.saveUserAttribute(this.userAttribute))
          .catch(() => Toaster.toast('Something went wrong while saving the preferences', Type.Error));
      }
    } else {
      await this.saveUserAttribute(this.userAttribute);
    }
  }

  public async saveUserAttribute(userAttribute) {
    const userId = this.storageService.getItem('profile_id');
    this.dataLoader = true;
    var response: UserAttributeInterface;
    this.checkNCashModified(this.previousUserAttribute, userAttribute);
    try {
      if (this.isPreferenceExist) {
        this.dataLoader = true;
        response = await this.userAttributeService.putUserAttribute({ investmentPreferences: userAttribute, automaticInvestmentsFromWallet: this.isFinzyBoltEnabled, isSwiftModified: this.checkSwiftModified(userAttribute), isNCashModified: this.isNCashModified }, userId);
      } else {
        this.dataLoader = true;
        response = await this.userAttributeService.postUserAttribute({ investmentPreferences: userAttribute, automaticInvestmentsFromWallet: this.isFinzyBoltEnabled, isSwiftModified: this.checkSwiftModified(userAttribute), isNCashModified: this.isNCashModified }, userId);
      }
      if (response.status === 0) {
        this.dataLoader = false;
        this.storageService.saveItem(Keys.INVESTMENT_PREFERENCES, 'true');
        Toaster.toast('Your preferences have been updated successfully!', Type.Success);
        this.router.navigate([this.step.nextLink]);
      } else {
        this.dataLoader = false;
        Toaster.toast('Failed to update preference. Please try again after sometime.', Type.Error);
      }
    }
    catch (e) {
      this.dataLoader = false;
      Toaster.toast('Something went wrong. Please try again after sometime.', Type.Error);
    }
  }

  public getFileUrlByName(fileName): string {
    return this.configService.getPolicyFileUrlByName(fileName);
  }

  /* * * * * * * * * * * * * * * * * * * * * * * * * loanPreference starts * * * * * * * * * * * * * * * * * * * * * * * */

  public setLoanPreferencesDefaultValues() {
    let riskRange: Array<string> = [];
    this.userAttributes.forEach(async attribute => {
      switch (attribute.attributeCode) {
        case AttributeCode.PREFERRED_LOAN_TENURE:
          this.userAttributesForm.get("loanPreference.tenurePreference").setValue(attribute.attributeValue);
          this.tenurePreferenceToggle = attribute.attributeValue;
          break;

        case AttributeCode.PREFERRED_MAX_LOAN_ALLOCATION_AMOUNT_PERCENTAGE:
          this.userAttributesForm.get("loanPreference.maxLoanAmount").setValue(attribute.attributeValue);
          this.maxLoanAmountToggle = attribute.attributeValue;
          break;

        case AttributeCode.FLEX_PREFERRED_RATING_LOW_RISK:
        case AttributeCode.FLEX_PREFERRED_RATING_MEDIUM_RISK:
        case AttributeCode.FLEX_PREFERRED_RATING_HIGH_RISK:
          riskRange.push(attribute.attributeValue)
          this.userAttributesForm.get("loanPreference.interestRateRiskRange").setValue(riskRange);
          this.interestRateRiskRangeToggle = riskRange;
          break;
      }
    });

    if (!this.userAttributesForm.get("loanPreference.maxLoanAmount").value) {
      this.userAttributesForm.get("loanPreference.maxLoanAmount").setValue(this.maxLoanAmountToggle);
    }

    if (!this.userAttributesForm.get("loanPreference.tenurePreference").value) {
      this.userAttributesForm.get("loanPreference.tenurePreference").setValue(this.tenurePreferenceToggle);
    }

    if (!this.userAttributesForm.get("loanPreference.interestRateRiskRange").value.value) {
      this.userAttributesForm.get("loanPreference.interestRateRiskRange").setValue(Object.values(RISK_RANGE));
      const event = { value: Object.values(RISK_RANGE) };
      this.interestRateChange(event, false);
    } else {
      const event = { value: this.userAttributesForm.get("loanPreference.interestRateRiskRange").value.value };
      this.interestRateChange(event, false);
    }
  }

  public interestRateChange(event: any, isComingFromForm?: boolean) {
    const selectedRiskLevels: Array<string> = event.value;

    if (Array.isArray(selectedRiskLevels)) {
      this.userAttributesForm
        .get("loanPreference.interestRateRiskRange")
        .setValue(selectedRiskLevels);

      if (this.getScores(selectedRiskLevels)) {
        this.expectedReturn.F6 = this.riskScore.F6[this.getScores(selectedRiskLevels)] ?? 0;
        this.expectedReturn.F12 = this.riskScore.F12[this.getScores(selectedRiskLevels)] ?? 0;
        this.expectedReturn.F24 = this.riskScore.F24[this.getScores(selectedRiskLevels)] ?? 0;
        this.expectedReturn.F36 = this.riskScore.F36[this.getScores(selectedRiskLevels)] ?? 0;
        this.expectedReturn.F18 = this.riskScore.F18[this.getScores(selectedRiskLevels)] ?? 0;
      }
      else {
        this.expectedReturn.F6 = 0;
        this.expectedReturn.F12 = 0;
        this.expectedReturn.F24 = 0;
        this.expectedReturn.F36 = 0;
        this.expectedReturn.F18 = 0;
      }

      this.userAttributesForm
        .get("loanPreference.expectedReturn.F6")
        .setValue(this.expectedReturn.F6);
      this.userAttributesForm
        .get("loanPreference.expectedReturn.F12")
        .setValue(this.expectedReturn.F12);
      this.userAttributesForm
        .get("loanPreference.expectedReturn.F24")
        .setValue(this.expectedReturn.F24);
      this.userAttributesForm
        .get("loanPreference.expectedReturn.F36")
        .setValue(this.expectedReturn.F36);
      this.userAttributesForm
        .get("loanPreference.expectedReturn.F18")
        .setValue(this.expectedReturn.F18);
    }

    this.showFormPreferenceForm = true;
  }

  public maxLoanAmountChange(event: any) {
    const selectedValue = event.value;
    this.userAttributesForm.get("loanPreference.maxLoanAmount").setValue(selectedValue);
  }

  public preferredTenureChange(event: any) {
    const selectedValue = event.value;
    this.userAttributesForm.get("loanPreference.tenurePreference").setValue(selectedValue);
  }

  public getProductFromRiskScore() {
		const sortedKeys: Array<string> = Object.keys(this.riskScore).sort((a, b) => {
			const sumA = Object.values(this.riskScore[a]).reduce((acc, curr) => acc + curr, 0);
			const sumB = Object.values(this.riskScore[b]).reduce((acc, curr) => acc + curr, 0);
			return sumA - sumB;
		});
		return sortedKeys;
	}

  public isLoanFlexPreferenceExists(loanPreferences: any): boolean {
    if (
      loanPreferences.maxLoanAmount &&
      loanPreferences.tenurePreference &&
      loanPreferences.interestRateRiskRange &&
      loanPreferences.interestRateRiskRange.length
    ) {
      return true;
    } else {
      return false;
    }
  }

  private async getRiskScore(): Promise<void> {
    const lenderId: string = this.storageService.getItem(Keys.LENDER_ID);
    this.productService.getRiskScore(lenderId)
      .then((res) => {
        this.riskScore = res;
        this.setLoanPreferencesDefaultValues();
      })
      .catch((err) => {
        console.log(err)
      })
  }

  private getScores(riskRangeArray: Array<string>): number {
    let scores: number = 0;
    riskRangeArray.forEach(range => {
      scores = this.riskRangeScore[range] + scores;
    });
    return scores;
  }

  /* * * * * * * * * * * * * * * * * * * * * * * * * loanPreference end * * * * * * * * * * * * * * * * * * * * * * * */

}
